import {
	PostAccessManagementPermissionsModel,
	PostAccessManagementPermissionsParams,
} from 'domain/usecases/private/profile/post-access-management-permissions';
import {makePostAccessManagementPermissions} from 'main/factories/usecases';

export async function postAccessManagementPermissions(
	params: PostAccessManagementPermissionsParams,
): Promise<PostAccessManagementPermissionsModel> {
	return makePostAccessManagementPermissions().post(params);
}
